export function openFileSelect({ onSelect, accept }: { onSelect: (files: FileList | null) => void; accept?: string }) {
  const fileInput = document.createElement('input');
  fileInput.type = 'file';
  fileInput.multiple = true;
  if (accept) {
    fileInput.accept = accept;
  }

  const changeHandler = (event: Event) => {
    const files = (event.target as HTMLInputElement).files;
    onSelect(files);
    fileInput.removeEventListener('change', changeHandler);

    fileInput.remove();
  };

  fileInput.addEventListener('change', changeHandler);

  fileInput.click();
}
